import {YesNoChoice} from '@/model/src/values/dv-3';
import {DomainValueReference} from '@/model/types';
import {InvestorAccount} from '@/types/client-info';

export const mapAccountFabToDomainValue = (fab: InvestorAccount['fab'] | undefined): DomainValueReference | null => {
  if (fab === true) return {$ref: YesNoChoice.YES};
  if (fab === false) return {$ref: YesNoChoice.NO};
  return null;
};
